import { render, staticRenderFns } from "./ClientZoneUserProfile.vue?vue&type=template&id=2a554c75&"
import script from "./ClientZoneUserProfile.vue?vue&type=script&lang=ts&"
export * from "./ClientZoneUserProfile.vue?vue&type=script&lang=ts&"
import style0 from "./ClientZoneUserProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports